// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"458":"bd3265cf","488":"0bfbd17a"}[chunkId] + ".chunk.js";
};